
import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { SchedulerBaseService } from "./scheduler.base.service";

@Injectable({
  providedIn: "root",
})
export class BookingPageService extends SchedulerBaseService {
  
  constructor(public provider: ServiceProvider) {
    super("api/account-sessions/", provider);
    
  }

  public save(data) {
   return this.save(data)
  }
  
  public getById(id:string) {
    return this.getList("/data" + `/${id}`);
  }

}